const EXTENSION_BY_TYPE: Record<string, string> = { 'image/png': '.png', 'image/jpeg': '.jpg', 'image/svg+xml': '.svg', 'image/webp': '.webp' };
const IMAGE_EXTENSION = /\.(png|jpe?g|svg|webp)$/i;
const MAX_FILENAME_LENGTH = 64;

export function splitFilename(filename: string, fileType?: string) {
  const match = filename.match(IMAGE_EXTENSION);
  if (match) return { name: filename.slice(0, match.index), extension: match[0] };
  return { name: filename, extension: EXTENSION_BY_TYPE[fileType ?? ''] ?? '' };
}

export function joinFilename(name: string, extension: string) {
  return name.trim() + extension;
}

export function isValidImageName(name: string, extension: string) {
  return name.trim().length > 0 && joinFilename(name, extension).length <= MAX_FILENAME_LENGTH;
}
